<template>
  <div class="form-group dodel-typeahead mb-0 w-100">
    <div
      class="overlay"
      v-if="show_dropdown"
      @click="show_dropdown = false"
    ></div>
    <input
      type="text"
      :placeholder="$t('message.start_typing_or_select')"
      v-model="search"
      class="form-control form-control-sm ml-2"
      @focus.prevent.stop="show_dropdown = true"
      style="height: 34px"
    />
    <button v-if="search !== ''" class="btn btn-link" @click="clearSelection()">
      &times;
    </button>
    <div class="dropdown" v-if="show_dropdown">
      <ul>
        <li v-for="result in results()" @click.prevent.stop="select(result)">
          {{ result }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      show_dropdown: false,
    };
  },
  props: {
    options: {
      type: Array,
    },
  },
  methods: {
    clearSelection() {
      this.$emit("clear-selection");
      this.show_dropdown = false;
      this.search = "";
    },
    select(item) {
      this.show_dropdown = false;
      this.$emit("hit", item);
      this.search = item;
    },
    results() {
      if (this.search !== "") {
        let re = new RegExp(this.search, "i");
        return this.options.filter((item) => re.test(item)).slice(0, 10);
      }
      return this.options.slice(0, 10);
    },
  },
  computed: {},
};
</script>
<style scoped>
.dodel-typeahead .overlay {
  position: fixed;
  z-index: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
}
.dodel-typeahead .form-control {
  position: relative;
  z-index: 1;
}
.dodel-typeahead .dropdown {
  position: absolute;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  width: 100%;
  margin-left: 8px;
  border-radius: 10px;
  padding: 10px 0;
}
.dodel-typeahead .dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dodel-typeahead .dropdown ul li {
  padding: 5px 15px;
  cursor: pointer;
}
.dodel-typeahead .dropdown ul li:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.dodel-typeahead .btn.btn-link {
  position: absolute;
  z-index: 2;
  top: 9px;
  right: 0;
  padding: 0;
  text-decoration: none;
}
</style>
